import * as Yup from 'yup';
import VALUE_TYPES from '../../../configs/ValueTypeConstants';
// Location
export const InitialLocationState = {
    name: "",
};

export const LocationSchema = Yup.object().shape({
    name: Yup.string().required(),
});

// Department
export const InitialDepartmentState = {
    name: "",
};

export const DepartmentSchema = Yup.object().shape({
    name: Yup.string().required(),
});

// Calendar management
export const InitialAcademicYearState = {
    academic_year: null,
    start_date: null,
    end_date: null
};

export const AcademicYearSchema = Yup.object().shape({
    academic_year: Yup.string().required(),
    start_date: Yup.date().required(),
    end_date: Yup.date().required(),
});

export const AcademicYearFormFields = [
    { name: "academic_year", title: "Academic Year", required: true, type: VALUE_TYPES.TEXT },
    { name: "start_date", title: "Start Date", required: true, type: VALUE_TYPES.DATEPICKER },
    { name: "end_date", title: "End Date", required: true, type: VALUE_TYPES.DATEPICKER }
];

// Transport Type
export const InitialTransportTypeState = {
    type: null,
    remark: null,
    // type_number: null,
    schools: []
};

export const TransportTypeSchema = Yup.object().shape({
    type: Yup.string().required(),
    remark: Yup.string().nullable(),
    // type_number: Yup.number().required().min(1).max(2),
    schools: Yup.array().min(1).required()
});

export const TransportTypeFormFields = [
    { name: "type", title: "Type", required: true, type: VALUE_TYPES.TEXT },
    { name: "remark", title: "Remark", required: false, type: VALUE_TYPES.TEXT },
    // { name: "type_number", title: "Type Number", required: true, type: VALUE_TYPES.NUMBER },
    { name: "schools", title: "Schools", required: true, type: VALUE_TYPES.MULTISELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" }
];

// Zone
export const InitialZoneState = {
    name: null,
    one_way_amount: null,
    two_way_amount: null,
    areas: [],
    school_id: null,
};

export const ZoneSchema = Yup.object().shape({
    name: Yup.string().required(),
    one_way_amount: Yup.number().required().min(0),
    two_way_amount: Yup.number().required().min(0),
    areas: Yup.array().min(1).required(),
    school_id: Yup.number().required(),
});

export const ZoneFormFields = [
    { name: "name", title: "Name", required: true, type: VALUE_TYPES.TEXT },
    { name: "one_way_amount", title: "One Way Amount", required: true, type: VALUE_TYPES.DECIAML },
    { name: "two_way_amount", title: "Two Way Amount", required: true, type: VALUE_TYPES.DECIAML },
    { name: "school_id", title: "School", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "areas", title: "Areas", required: true, type: VALUE_TYPES.MULTISELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" }
];


// Bus Details
export const InitialBusDetailState = {
    bus_number: null,
    route_covered: null
};

export const BusDetailSchema = Yup.object().shape({
    bus_number: Yup.string().required(),
    route_covered: Yup.string().required()
});

export const BusDetailFormFields = [
    { name: "bus_number", title: "Bus Number", required: true, type: VALUE_TYPES.TEXT },
    { name: "route_covered", title: "Route Covered", required: true, type: VALUE_TYPES.TEXT }
];

// Area
export const InitialAreaState = {
    name: "",
    remark: "",
};

export const AreaSchema = Yup.object().shape({
    name: Yup.string().required(),
    remark: Yup.string().nullable()
});

export const AreaFormFields = [
    { name: "name", title: "Name", required: true, type: VALUE_TYPES.TEXT },
    { name: "remark", title: "Remark", required: false, type: VALUE_TYPES.TEXT }
];

// Fee Type
export const InitialFeesTypeState = {
    name: null,
    invoice: false,
    schools: []
};

export const FeesTypeSchema = Yup.object().shape({
    name: Yup.string().required(),
    invoice: Yup.boolean().required(),
    schools: Yup.array().min(1).required()
});

export const FeesTypeFormFields = [
    { name: "name", title: "Name", required: true, type: VALUE_TYPES.TEXT },
    { name: "invoice", title: "Invoice", required: true, type: VALUE_TYPES.RADIO, options: [{ id: true, name: "Include" }, { id: false, name: "Exclude" }], apiRequired: false, displayKey: "name", itemValue: "id" },
    { name: "schools", title: "Schools", required: true, type: VALUE_TYPES.MULTISELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" }
];

// Fee Setup
export const InitialFeesSetupState = {
    name: null,
    no_of_months: null,
    start_month: undefined,
    end_month: undefined,
    schools: []
};

export const FeesSetupSchema = Yup.object().shape({
    name: Yup.string().required(),
    no_of_months: Yup.number().min(0).max(12),
    start_month: Yup.date().required(),
    end_month: Yup.date().required(),
    schools: Yup.array().min(1).required()
});

export const FeesSetupFormFields = [
    { name: "name", title: "Name", required: true, type: VALUE_TYPES.TEXT },
    { name: "no_of_months", title: "No of month", required: true, type: VALUE_TYPES.NUMBER },
    { name: "start_month", title: "Start Month", required: true, type: VALUE_TYPES.DATEPICKER },
    { name: "end_month", title: "End Month", required: true, type: VALUE_TYPES.DATEPICKER },
    { name: "schools", title: "Schools", required: true, type: VALUE_TYPES.MULTISELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" }
];

// TRANSACTION CODE
export const InitialTransactionCodeSetupState = {
    type: null,
    starting_no: null,
    tag: null,
    schools: []
};

export const TransactionCodeSetupSchema = Yup.object().shape({
    type: Yup.string().required(),
    starting_no: Yup.number().min(0),
    tag: Yup.string().required(),
    schools: Yup.array().min(1).required()
});

export const TransactionCodeSetupFormFields = [
    { name: "type", title: "Type", required: true, type: VALUE_TYPES.SELECT, options: [{ name: "Invoice" }, { name: "Receipt" }], apiRequired: true, displayKey: "name", itemValue: "name" },
    { name: "starting_no", title: "Starting No", required: true, type: VALUE_TYPES.NUMBER },
    { name: "tag", title: "Tag", required: true, type: VALUE_TYPES.TEXT },
    { name: "schools", title: "Schools", required: true, type: VALUE_TYPES.MULTISELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" }
];


// CLASS PROMOTION
export const InitialClassPromotionState = {
    old_class_id: null,
    new_class_id: null,
    academic_year_id: null,
    schools: []
};

export const ClassPromotionSchema = Yup.object().shape({
    old_class_id: Yup.number().required(),
    new_class_id: Yup.number().required(),
    academic_year_id: Yup.number().required(),
    schools: Yup.array().min(1).required()
});

export const ClassPromotionFormFields = [
    { name: "old_class_id", title: "Old Class", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "new_class_id", title: "New Class", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "academic_year_id", title: "Academic Year", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "academic_year", itemValue: "id" },
    { name: "schools", title: "Schools", required: true, type: VALUE_TYPES.MULTISELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" }
];

// ROUTE CHANGE
export const InitialRouteChangeState = {
    type: "Pro Rate",
    school_id: null,
    student_id: null,
    from_date: null,
    end_date: null,
    discount_percentage: null,
    remarks: null
};

export const RouteChangeSchema = Yup.object().shape({
    type: Yup.string().required(),
    school_id: Yup.number().required(),
    student_id: Yup.number().required(),
    from_date: Yup.date().required(),
    end_date: Yup.date().required(),
    discount_percentage: Yup.number().required(),
    remarks: Yup.string().nullable()
});

export const RouteChangeFormFields = [
    { name: "type", title: "Type", required: true, type: VALUE_TYPES.RADIO, options: [{ id: "Route Change" }, { id: "Pro Rate" }], apiRequired: false, displayKey: "id", itemValue: "id" },
    { name: "school_id", title: "School", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "student_id", title: "Student", required: true, type: VALUE_TYPES.AUTOCOMPLETE, options: [], apiRequired: true, displayKey: "code_name", itemValue: "id" },
    { name: "from_date", title: "From Date", required: true, type: VALUE_TYPES.DATEPICKER },
    { name: "end_date", title: "End Date", required: true, type: VALUE_TYPES.DATEPICKER },
    { name: "discount_percentage", title: "Discount %", required: true, type: VALUE_TYPES.DECIAML },
    { name: "remarks", title: "Remarks", required: false, type: VALUE_TYPES.TEXT },

];

// FINANCE TRANSACTION CODE
export const InitialFinanceTransactionCodeSetupState = {
    transaction: null,
    short_code: null,
    starting_no: null,
    reset_for_nfy: false,
};

export const FinanceTransactionCodeSetupSchema = Yup.object().shape({
    transaction: Yup.string().required(),
    short_code: Yup.string().required(),
    starting_no: Yup.number().min(0),
    reset_for_nfy: Yup.boolean().required(),
});

export const FinanceTransactionCodeSetupFormFields = [
    { name: "transaction", title: "Transaction", required: true, type: VALUE_TYPES.TEXT },
    { name: "short_code", title: "Short Code", required: true, type: VALUE_TYPES.TEXT },
    { name: "starting_no", title: "Starting No", required: true, type: VALUE_TYPES.NUMBER },
    { name: "reset_for_nfy", title: "Reset for next financial year", required: true, type: VALUE_TYPES.RADIO, options: [{ id: true, name: "Yes" }, { id: false, name: "No" }], apiRequired: false, displayKey: "name", itemValue: "id" },
];

// Mode of pay
export const InitialModeOfPayState = {
    mode_of_pay: null,
    description: null,
};

export const ModeOfPaySchema = Yup.object().shape({
    mode_of_pay: Yup.string().required(),
    description: Yup.string().required(),
});

export const ModeOfPayFormFields = [
    { name: "mode_of_pay", title: "Mode of pay", required: true, type: VALUE_TYPES.TEXT },
    { name: "description", title: "Description", required: true, type: VALUE_TYPES.TEXT },
];

// Currency
export const InitialCurrencyState = {
    country_code: null,
    country_name: null,
    currency_code: null,
    currency_description: null,
    convert_rate: null,
};

export const CurrencySchema = Yup.object().shape({
    country_code: Yup.string().required(),
    country_name: Yup.string().required(),
    currency_code: Yup.string().required(),
    currency_description: Yup.string().required(),
    convert_rate: Yup.number().min(0).required(),
});

export const CurrencyFormFields = [
    { name: "country_code", title: "Country Code", required: true, type: VALUE_TYPES.TEXT },
    { name: "country_name", title: "Country Name", required: true, type: VALUE_TYPES.TEXT },
    { name: "currency_code", title: "Currency Code", required: true, type: VALUE_TYPES.TEXT },
    { name: "currency_description", title: "Currency Description", required: true, type: VALUE_TYPES.TEXT },
    { name: "convert_rate", title: "Convert Rate", required: true, type: VALUE_TYPES.DECIAML },
];

// Customer
export const InitialCustomerState = {
    cgrp_no: null,
    cgrp_name: null,
    status: null,
    code: null,
    customer_prefix: null,
    name: null,
    tax_no: null,
    type: null,
    fax_no: null,
    telephone_no: null,
    email: null,
    website: null,
    area: null,
    location: null,
    contact_person: null,
    credit_limit: null,
    credit_period: null,
    address1: null,
    address2: null,
    remark: null,
    currency_id: null
};

export const CustomerSchema = Yup.object().shape({
    cgrp_no: Yup.string().nullable(),
    cgrp_name: Yup.string().nullable(),
    status: Yup.string().required(),
    code: Yup.string().required(),
    customer_prefix: Yup.string().nullable(),
    name: Yup.string().required(),
    tax_no: Yup.string().nullable(),
    type: Yup.string().nullable(),
    fax_no: Yup.string().nullable(),
    telephone_no: Yup.string().nullable(),
    email: Yup.string().nullable().email(),
    website: Yup.string().nullable(),
    area: Yup.string().nullable(),
    location: Yup.string().nullable(),
    contact_person: Yup.string().nullable(),
    credit_limit: Yup.string().required(),
    credit_period: Yup.string().nullable(),
    address1: Yup.string().nullable(),
    address2: Yup.string().nullable(),
    remark: Yup.string().nullable(),
    currency_id: Yup.number().required()
});

export const CustomerFormFields = [
    { name: "cgrp_no", title: "CGRP No", required: false, type: VALUE_TYPES.TEXT },
    { name: "cgrp_name", title: "CGRP Name", required: false, type: VALUE_TYPES.TEXT },
    { name: "status", title: "Status", required: true, type: VALUE_TYPES.SELECT, options: [{ id: "Approved", name: "Approved" }, { id: "Not Approved", name: "Not Approved" }, { id: "Blocked", name: "Blocked" }], apiRequired: false, displayKey: "name", itemValue: "id" },
    { name: "code", title: "Customer Code", required: true, type: VALUE_TYPES.TEXT },
    { name: "customer_prefix", title: "Prefix", required: false, type: VALUE_TYPES.TEXT },
    { name: "name", title: "Customer Name", required: true, type: VALUE_TYPES.TEXT },
    { name: "tax_no", title: "Tax No", required: false, type: VALUE_TYPES.TEXT },
    { name: "type", title: "Customer Type", required: false, type: VALUE_TYPES.TEXT },
    { name: "fax_no", title: "Fax No", required: false, type: VALUE_TYPES.TEXT },
    { name: "telephone_no", title: "Telephone No", required: false, type: VALUE_TYPES.TEXT },
    { name: "email", title: "Email", required: false, type: VALUE_TYPES.TEXT },
    { name: "website", title: "Website", required: false, type: VALUE_TYPES.TEXT },
    { name: "area", title: "Area", required: false, type: VALUE_TYPES.TEXT },
    { name: "location", title: "Location", required: false, type: VALUE_TYPES.TEXT },
    { name: "contact_person", title: "Contact Person", required: false, type: VALUE_TYPES.TEXT },
    { name: "currency_id", title: "Currency", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "currency_code", itemValue: "id" },
    { name: "credit_limit", title: "Credit Limit", required: true, type: VALUE_TYPES.TEXT },
    { name: "credit_period", title: "Credit Period", required: false, type: VALUE_TYPES.TEXT },
    { name: "address1", title: "Address 1", required: false, type: VALUE_TYPES.TEXTAREA },
    { name: "address2", title: "Address 2", required: false, type: VALUE_TYPES.TEXTAREA },
    { name: "remark", title: "Remark", required: false, type: VALUE_TYPES.TEXTAREA },
];


// Supplier
export const InitialSupplierState = {
    account_id: null,
    cgrp_name: null,
    status: null,
    code: null,
    supplier_prefix: null,
    name: null,
    tax_no: null,
    type: null,
    fax_no: null,
    telephone_no: null,
    email: null,
    website: null,
    area: null,
    location: null,
    contact_person: null,
    credit_limit: null,
    credit_period: null,
    address1: null,
    address2: null,
    remark: null,
    currency_id: null
};

export const SupplierSchema = Yup.object().shape({
    account_id: Yup.number().required(),
    cgrp_name: Yup.string().nullable(),
    status: Yup.string().required(),
    code: Yup.string().required(),
    supplier_prefix: Yup.string().nullable(),
    name: Yup.string().required(),
    tax_no: Yup.string().nullable(),
    type: Yup.string().nullable(),
    fax_no: Yup.string().nullable(),
    telephone_no: Yup.string().nullable(),
    email: Yup.string().nullable().email(),
    website: Yup.string().nullable(),
    area: Yup.string().nullable(),
    location: Yup.string().nullable(),
    contact_person: Yup.string().nullable(),
    credit_limit: Yup.string().required(),
    credit_period: Yup.string().nullable(),
    address1: Yup.string().nullable(),
    address2: Yup.string().nullable(),
    remark: Yup.string().nullable(),
    currency_id: Yup.number().required()
});

export const SupplierFormFields = [
    { name: "account_id", title: "CGRP No", required: true, type: VALUE_TYPES.AUTOCOMPLETE, options: [], apiRequired: true, displayKey: "code_name", itemValue: "id" },
    { name: "cgrp_name", title: "CGRP Name", required: false, type: VALUE_TYPES.TEXT },
    { name: "status", title: "Status", required: true, type: VALUE_TYPES.SELECT, options: [{ id: "Approved", name: "Approved" }, { id: "Not Approved", name: "Not Approved" }, { id: "Blocked", name: "Blocked" }], apiRequired: false, displayKey: "name", itemValue: "id" },
    { name: "code", title: "Supplier Code", required: true, type: VALUE_TYPES.TEXT },
    { name: "supplier_prefix", title: "Prefix", required: false, type: VALUE_TYPES.TEXT },
    { name: "name", title: "Supplier Name", required: true, type: VALUE_TYPES.TEXT },
    { name: "tax_no", title: "Tax No", required: false, type: VALUE_TYPES.TEXT },
    { name: "type", title: "Supplier Type", required: false, type: VALUE_TYPES.TEXT },
    { name: "fax_no", title: "Fax No", required: false, type: VALUE_TYPES.TEXT },
    { name: "telephone_no", title: "Telephone No", required: false, type: VALUE_TYPES.TEXT },
    { name: "email", title: "Email", required: false, type: VALUE_TYPES.TEXT },
    { name: "website", title: "Website", required: false, type: VALUE_TYPES.TEXT },
    { name: "area", title: "Area", required: false, type: VALUE_TYPES.TEXT },
    { name: "location", title: "Location", required: false, type: VALUE_TYPES.TEXT },
    { name: "contact_person", title: "Contact Person", required: false, type: VALUE_TYPES.TEXT },
    { name: "currency_id", title: "Currency", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "currency_code", itemValue: "id" },
    { name: "credit_limit", title: "Credit Limit", required: true, type: VALUE_TYPES.TEXT },
    { name: "credit_period", title: "Credit Period", required: false, type: VALUE_TYPES.TEXT },
    { name: "address1", title: "Address 1", required: false, type: VALUE_TYPES.TEXTAREA },
    { name: "address2", title: "Address 2", required: false, type: VALUE_TYPES.TEXTAREA },
    { name: "remark", title: "Remark", required: false, type: VALUE_TYPES.TEXTAREA },
];
// Account Ledger
export const InitialAccountLedgerState = {
    account_id: null,
    bank_doc_code: null,
    no_of_digits_rep: null,
    no_of_digits_pay: null,
};

export const AccountLedgerSchema = Yup.object().shape({
    account_id: Yup.number().required(),
    bank_doc_code: Yup.string().required(),
    no_of_digits_rep: Yup.number().required(),
    no_of_digits_pay: Yup.number().required(),
});

export const AccountLedgerFormFields = [
    { name: "account_id", title: "Account", required: true, type: VALUE_TYPES.AUTOCOMPLETE, options: [], apiRequired: true, displayKey: "code_name", itemValue: "id" },
    { name: "bank_doc_code", title: "Bank Doc Code", required: true, type: VALUE_TYPES.TEXT },
    { name: "no_of_digits_rep", title: "No Of Digits REP", required: true, type: VALUE_TYPES.NUMBER },
    { name: "no_of_digits_pay", title: "No Of Digits Pay", required: true, type: VALUE_TYPES.NUMBER },
];

// Bank Detail
export const InitialBankDetailState = {
    bank_code: null,
    bank_name: null,
    country: null,
    city: null,
    state: null,
    zip_code: null,
    ifsc_code: null,
    micr_code: null,
    account_code: null,
    transaction_no: null,
    address1: null,
    address2: null,
};

export const BankDetailSchema = Yup.object().shape({
    bank_code: Yup.string().required(),
    bank_name: Yup.string().required(),
    country: Yup.string().nullable(),
    city: Yup.string().nullable(),
    state: Yup.string().nullable(),
    zip_code: Yup.string().nullable(),
    ifsc_code: Yup.string().nullable(),
    micr_code: Yup.string().nullable(),
    bank_agent_id: Yup.string().nullable(),
    transaction_no: Yup.string().nullable(),
    address1: Yup.string().nullable(),
    address2: Yup.string().nullable(),
});

export const BankDetailFormFields = [
    { name: "bank_code", title: "Bank Code", required: true, type: VALUE_TYPES.TEXT },
    { name: "bank_name", title: "Bank Name", required: true, type: VALUE_TYPES.TEXT },
    { name: "country", title: "Country", required: false, type: VALUE_TYPES.TEXT },
    { name: "city", title: "City", required: false, type: VALUE_TYPES.TEXT },
    { name: "state", title: "State", required: false, type: VALUE_TYPES.TEXT },
    { name: "zip_code", title: "Zip Code", required: false, type: VALUE_TYPES.TEXT },
    { name: "ifsc_code", title: "IFSC Code", required: false, type: VALUE_TYPES.TEXT },
    { name: "micr_code", title: "MICR Code", required: false, type: VALUE_TYPES.TEXT },
    { name: "bank_agent_id", title: "Bank Agent ID", required: false, type: VALUE_TYPES.TEXT },
    { name: "transaction_no", title: "Transaction No", required: false, type: VALUE_TYPES.TEXT },
    { name: "address1", title: "Address 1", required: false, type: VALUE_TYPES.TEXTAREA },
    { name: "address2", title: "Address 2", required: false, type: VALUE_TYPES.TEXTAREA },
];

// Cash Ledger
export const InitialCashLedgerState = {
    school_id: null,
    account_code: null,
};

export const CashLedgerSchema = Yup.object().shape({
    account_code: Yup.string().required(),
    school_id: Yup.number().required(),
});

export const CashLedgerFormFields = [
    { name: "school_id", title: "School", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "account_code", title: "Account Code", required: true, type: VALUE_TYPES.TEXT },
];

// Grades
export const InitialGradeState = {
    name: null,
    schools: []
};

export const GradeSchema = Yup.object().shape({
    name: Yup.string().required(),
    schools: Yup.array().min(1).required()
});

export const GradeFormFields = [
    { name: "name", title: "Name", required: true, type: VALUE_TYPES.TEXT },
    { name: "schools", title: "Schools", required: true, type: VALUE_TYPES.MULTISELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" }
];

// Terms
export const InitialTermState = {
    name: null,
    start_date: null,
    end_date: null,
    schools: [],
    academic_year_id: null
};

export const TermSchema = Yup.object().shape({
    name: Yup.string().required(),
    start_date: Yup.date().required(),
    end_date: Yup.date().required(),
    schools: Yup.array().min(1).required(),
    academic_year_id: Yup.number().required()
});

export const TermFormFields = [
    { name: "name", title: "Name", required: true, type: VALUE_TYPES.TEXT },
    { name: "start_date", title: "Start Date", required: true, type: VALUE_TYPES.DATEPICKER },
    { name: "end_date", title: "End Date", required: true, type: VALUE_TYPES.DATEPICKER },
    { name: "schools", title: "Schools", required: true, type: VALUE_TYPES.MULTISELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "academic_year_id", title: "Academic Year", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "academic_year", itemValue: "id" },
];

// MainGroupLedger
export const InitialMainGroupLedgerState = {
    sub_account_id: null
};

export const MainGroupLedgerSchema = Yup.object().shape({
    sub_account_id: Yup.number().required()
});

export const MainGroupLedgerFormFields = [
    { name: "sub_account_id", title: "Group Id", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "code", itemValue: "id" },
    { name: "sub_account_id", title: "Group Name", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id", disabled: true }
];

// MainGroupLedgerAccount
export const InitialMainGroupLedgerAccountState = {
    school_id: null,
    account_id: null
};

export const MainGroupLedgerAccountSchema = Yup.object().shape({
    school_id: Yup.number().required(),
    account_id: Yup.number().required()
});

export const MainGroupLedgerAccountFormFields = [
    { name: "account_id", title: "Account", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "school_id", title: "School", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" }
];


const clmFilterState = {
    from_date: null,
    to_date: null,
    status: null,
};

const clmFilterSchema = Yup.object().shape({
    from_date: Yup.date().nullable(),
    to_date: Yup.date().nullable(),
    status: Yup.string().nullable(),
});

const clmFilterFormFields: any[] = [
    { name: "from_date", title: "From Date", required: false, type: VALUE_TYPES.DATEPICKER },
    { name: "to_date", title: "To Date", required: false, type: VALUE_TYPES.DATEPICKER },
    { name: "status", title: "Status", required: false, type: VALUE_TYPES.SELECT, options: [{ name: "Active" }, { name: "In-Active" }], apiRequired: true, displayKey: "name", itemValue: "name" },
];

const clsFilterState = {
    schools: null,
};

const clsFilterSchema = Yup.object().shape({
    schools: Yup.array().nullable(),
});

const clsFilterFormFields: any[] = [
    { name: "schools", title: "Schools", required: false, type: VALUE_TYPES.MULTISELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
];

const termsFilterState = {
    schools: null,
    academic_years: null,
    from_date: null,
    to_date: null,
};

const termsFilterSchema = Yup.object().shape({
    schools: Yup.array().nullable(),
    academic_years: Yup.array().nullable(),
    from_date: Yup.date().nullable(),
    to_date: Yup.date().nullable(),
});

const termsFilterFormFields: any[] = [
    { name: "schools", title: "Schools", required: false, type: VALUE_TYPES.MULTISELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "academic_years", title: "Academic Years", required: false, type: VALUE_TYPES.MULTISELECT, options: [], apiRequired: true, displayKey: "academic_year", itemValue: "id" },
    { name: "from_date", title: "From Date", required: false, type: VALUE_TYPES.DATEPICKER },
    { name: "to_date", title: "To Date", required: false, type: VALUE_TYPES.DATEPICKER },
];

const zonesFilterState = {
    schools: null,
    areas: null,
};

const zonesFilterSchema = Yup.object().shape({
    schools: Yup.array().nullable(),
    areas: Yup.array().nullable(),
});

const zonesFilterFormFields: any[] = [
    { name: "schools", title: "Schools", required: false, type: VALUE_TYPES.MULTISELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "areas", title: "Areas", required: false, type: VALUE_TYPES.MULTISELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
];

const ttFilterState = {
    schools: null,
};

const ttFilterSchema = Yup.object().shape({
    schools: Yup.array().nullable(),
});

const ttFilterFormFields: any[] = [
    { name: "schools", title: "Schools", required: false, type: VALUE_TYPES.MULTISELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
];

const ftFilterState = {
    schools: null,
};

const ftFilterSchema = Yup.object().shape({
    schools: Yup.array().nullable(),
});

const ftFilterFormFields: any[] = [
    { name: "schools", title: "Schools", required: false, type: VALUE_TYPES.MULTISELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
];

const fsFilterState = {
    schools: null,
    from_date: null,
    to_date: null,
};

const fsFilterSchema = Yup.object().shape({
    schools: Yup.array().nullable(),
    from_date: Yup.date().nullable(),
    to_date: Yup.date().nullable(),
});

const fsFilterFormFields: any[] = [
    { name: "schools", title: "Schools", required: false, type: VALUE_TYPES.MULTISELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "from_date", title: "From Date", required: false, type: VALUE_TYPES.DATEPICKER },
    { name: "to_date", title: "To Date", required: false, type: VALUE_TYPES.DATEPICKER },
];

const tcsFilterState = {
    schools: null,
};

const tcsFilterSchema = Yup.object().shape({
    schools: Yup.array().nullable(),
});

const tcsFilterFormFields: any[] = [
    { name: "schools", title: "Schools", required: false, type: VALUE_TYPES.MULTISELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
];

const alFilterState = {
    accounts: null,
};

const alFilterSchema = Yup.object().shape({
    accounts: Yup.array().nullable(),
});

const alFilterFormFields: any[] = [
    { name: "accounts", title: "Accounts", required: false, type: VALUE_TYPES.MULTISELECT, options: [], apiRequired: true, displayKey: "code_name", itemValue: "id" },
];

export const filter = {
    "Calendar Mgmts": {
        state: clmFilterState,
        schema: clmFilterSchema,
        formFields: clmFilterFormFields,
        apis: []
    },
    "Classes": {
        state: clsFilterState,
        schema: clsFilterSchema,
        formFields: clsFilterFormFields,
        apis: ["schools"]
    },
    "Terms": {
        state: termsFilterState,
        schema: termsFilterSchema,
        formFields: termsFilterFormFields,
        apis: ["schools", "academic_years"]
    },
    "Zones": {
        state: zonesFilterState,
        schema: zonesFilterSchema,
        formFields: zonesFilterFormFields,
        apis: ["schools", "areas"]
    },
    "Transport Types": {
        state: ttFilterState,
        schema: ttFilterSchema,
        formFields: ttFilterFormFields,
        apis: ["schools"]
    },
    "Fees Types": {
        state: ftFilterState,
        schema: ftFilterSchema,
        formFields: ftFilterFormFields,
        apis: ["schools"]
    },
    "Fees Setups": {
        state: fsFilterState,
        schema: fsFilterSchema,
        formFields: fsFilterFormFields,
        apis: ["schools"]
    },
    "Transaction Code Setups": {
        state: tcsFilterState,
        schema: tcsFilterSchema,
        formFields: tcsFilterFormFields,
        apis: ["schools"]
    },
    "Account Ledgers": {
        state: alFilterState,
        schema: alFilterSchema,
        formFields: alFilterFormFields,
        apis: ["accounts"]
    },
    "Main Group Ledgers": {
        state: alFilterState,
        schema: alFilterSchema,
        formFields: alFilterFormFields,
        apis: ["accounts"]
    },
    "Cash Ledgers": {
        state: tcsFilterState,
        schema: tcsFilterSchema,
        formFields: tcsFilterFormFields,
        apis: ["schools"]
    },
}
